/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Icon = styled.span`
  display: inline-block;
  ${(p) => p.round && 'border-radius: .25rem;'}
  ${(p) => p.circle && 'border-radius: 50%;'}
  ${(p) => (p.round || p.circle) && 'padding: .25rem;'}
  ${(p) => p.borderRound && 'border-radius: .25rem;'}
  ${(p) => p.borderRound && 'padding-bottom: 2px;'}
  background-color: ${(p) => p.bgColor || 'inherit'};

  line-height: 1;

  &:focus {
    outline: 0;
    box-shadow: 0 0 3px #0070D2;
  }
`;

const SVG = styled.svg`
  height: ${(p) => p.size ? p.size : '1rem'};
  width: ${(p) => p.size ? p.size : '1rem'};
  fill: white;
`;

/**
 * Icon Container for Standard SLDS Icons
 */
const StandardIcon = ({ className, onClick, icon, size, bgColor, round, circle, borderRound }) => (
  <Icon className={className} onClick={onClick} bgColor={bgColor} size={size} round={round} circle={circle} borderRound = {borderRound}>
    <SVG size={size}>
      <use xlinkHref={`/assets/icons/standard-sprite/svg/symbols.svg#${icon}`}></use>
    </SVG>
  </Icon>
);

StandardIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string
};

StandardIcon.defaultProps = {
  show: true,
};

export default StandardIcon;
